export default __webpack_public_path__ + "static/media/terminal-access-active.05bd76a4.svg";